import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import TextInput from "../../../../components/forms/textInput";
import styles from "./styles.module.scss";
import TextArea from "../../../../components/forms/textarea";

interface IStepOneProps {
  handleNext: () => void;
}

const StepOne = ({ handleNext }: IStepOneProps) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const isValid = !!watch("title") && !errors?.title && !errors?.description;
  const { t } = useTranslation();

  return (
    <div className={styles.stepOne}>
      <h2 className={styles.title}>{t("lbl_project_details")}</h2>
      <div className={styles.fieldBlock}>
        <Controller
          name="title"
          control={control}
          rules={{ required: true, max: 100, min: 5 }}
          render={({ field }) => (
            <TextInput
              {...field}
              maxCharacters={100}
              required
              label={t("lbl_title_placeholder")}
              placeholder={t("lbl_title_placeholder")}
              containerWidth="534px"
              hint={t("lbl_title_max_100_chars")}
              errorMessage={errors?.title?.message?.toString()}
            />
          )}
        />
      </div>
      <Controller
        name="description"
        control={control}
        rules={{ required: false, max: 2000, min: 10 }}
        render={({ field }) => (
          <TextArea
            {...field}
            containerClassName={styles.textAreaContainer}
            maxCharacters={2000}
            minInputHeight="127px"
            maxInputHeight="200px"
            placeholder={t("lbl_description_placeholder")}
            handleChange={field?.onChange}
            errorMessage={errors?.description?.message?.toString()}
          />
        )}
      />
      <PrimaryButton
        disabled={!isValid}
        onClick={handleNext}
        style={{
          background: isValid ? "#0D44AD" : "#EEF0F5",
          width: "534px",
        }}>
        {t("lbl_next")}
      </PrimaryButton>
    </div>
  );
};

export default StepOne;
